import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext, useLayoutEffect, useState } from 'react';
import cn from 'classnames';
import ddt from '@wix/da-ddt';
import noop from '../../utils/noop';
import { SubscriptionPurchaseFTUEContext } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import { useViewBlockChecks } from '../../DeviationViews/Full/hooks/useViewBlockChecks';
import { DEFAULT_MULTI_IMAGE_STAGE } from '../constants';
import { useMobileStage } from '../hooks/useMobileStage';
import Duperswiper from '../_partials/Duperswiper';
import ZoomModalFromImageSource from '../_partials/ZoomModalFromImageSource';
import MobileMultiArtScrollStage from './MobileMultiArtScrollStage';
import MobileMultiArtCarouselStage from './MobileMultiArtCarouselStage';
import styles from './MobileArtStage.scss';
const logger = ddt.createLogger('multifile');
export const MobileMultiArtStage = (_param)=>{
    var { deviation, className, zoomedImageSource, isZoomed, onEnterZoomMode = noop, onExitZoomMode = noop } = _param, props = _object_without_properties(_param, [
        "deviation",
        "className",
        "zoomedImageSource",
        "isZoomed",
        "onEnterZoomMode",
        "onExitZoomMode"
    ]);
    const [displayMode, setDisplayMode] = useState(DEFAULT_MULTI_IMAGE_STAGE);
    // if blocked/disabled, only show carousel
    const { hasBlock } = useViewBlockChecks(deviation);
    const StageComponent = displayMode === 'scroll' && !hasBlock ? MobileMultiArtScrollStage : MobileMultiArtCarouselStage;
    const [currentlyViewedImageSource, setCurrentlyViewedImageSource] = useState(deviation);
    // when duperbrowse switches between deviations, reset to show main image
    useLayoutEffect(()=>{
        setCurrentlyViewedImageSource(deviation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        deviation.deviationId
    ]);
    const isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);
    const { containerSize = {} } = useMobileStage(deviation);
    var _currentlyViewedImageSource_title;
    logger.log('DesktopMultiArtStage', {
        deviation: deviation.deviationId,
        displayMode,
        hasBlock,
        currentlyViewedImageSource: (_currentlyViewedImageSource_title = currentlyViewedImageSource === null || currentlyViewedImageSource === void 0 ? void 0 : currentlyViewedImageSource['title']) !== null && _currentlyViewedImageSource_title !== void 0 ? _currentlyViewedImageSource_title : currentlyViewedImageSource === null || currentlyViewedImageSource === void 0 ? void 0 : currentlyViewedImageSource['filename'],
        isSubscriptionPurchaseFTUEBeingShown,
        containerSize
    });
    var _zoomedImageSource_isPublished;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(styles['root'], styles[`${displayMode}-mode`], className)
    }, /*#__PURE__*/ React.createElement(Duperswiper, {
        className: styles['dont-hide-overflow-on-swiper'],
        deviation: deviation,
        width: containerSize === null || containerSize === void 0 ? void 0 : containerSize.width,
        height: "auto"
    }, (duperswiperDeviation)=>{
        return /*#__PURE__*/ React.createElement(StageComponent, _object_spread_props(_object_spread({}, props), {
            deviation: duperswiperDeviation,
            disabled: hasBlock,
            setDisplayMode: setDisplayMode,
            currentlyViewedImageSource: currentlyViewedImageSource,
            setCurrentlyViewedImageSource: setCurrentlyViewedImageSource,
            isZoomed: isZoomed,
            onEnterZoomMode: onEnterZoomMode,
            onExitZoomMode: onExitZoomMode
        }));
    }), zoomedImageSource && /*#__PURE__*/ React.createElement(ZoomModalFromImageSource, _object_spread_props(_object_spread({
        source: zoomedImageSource,
        allowFullviewSrcsetForPngs: (_zoomedImageSource_isPublished = zoomedImageSource === null || zoomedImageSource === void 0 ? void 0 : zoomedImageSource.isPublished) !== null && _zoomedImageSource_isPublished !== void 0 ? _zoomedImageSource_isPublished : false
    }, containerSize), {
        isZoomed: isZoomed,
        onExitZoomMode: onExitZoomMode
    })), isSubscriptionPurchaseFTUEBeingShown && /*#__PURE__*/ React.createElement(SubscriptionPurchaseFTUE, {
        className: styles['subscription-purchase-ftue']
    }));
};
MobileMultiArtStage.displayName = 'MobileMultiArtStage';
export default MobileMultiArtStage;

//# sourceMappingURL=MobileMultiArtStage.js.map